import React from 'react';
import PropTypes from 'prop-types';

import { faFileInvoiceDollar } from '@fortawesome/pro-solid-svg-icons';

import Button from 'shared/button';
import EmptyState from 'shared/empty_state';

export default function VoucherEmptyState({ onClick }) {
  return (
    <EmptyState
      bodyText="Create a draft voucher to get started"
      header="This deal does not have a voucher"
      icon={faFileInvoiceDollar}
    >
      <Button.Primary label="Create Voucher" onClick={onClick} />
    </EmptyState>
  );
}

VoucherEmptyState.propTypes = {
  onClick: PropTypes.func,
};
